<template>
    <div class="top-volunteers">
        <div class="container">
            <TopActiveVolunteersList :itemsList="itemsList"/>
            <div class="show-all&#45;&#45;button" @click="showMore" v-if="pagen&&pagen.showMore">
                {{ params.messages.showMore }}
            </div>
        </div>
    </div>
</template>

<script>
import TopActiveVolunteersList from './TopActiveVolunteersList.vue';
import {useAProgressBar} from "~/components/ui";
import {send} from "../../services/api";

export default {
    name: 'TopActiveVolunteersPage',

    props: ['params'],

    components: {
        TopActiveVolunteersList
    },

    data(){
      /*        [
            {
                id: 1,
                photoSrc: '/local/templates/main/img/nophoto.png',
                link: '/volonters/19.html',
                name: 'Василий Швецюю',
                jobTitle: 'Волонтер',
                registrationTitle: 'Дата регистрации:',
                registrationDate: '22.05.22',
                projectsCount: 12,
                goodMark: 10,
                rang: 1
            },
        ];*/
        return {
            progress: useAProgressBar(),
            itemsList: this.params.items,
            pagen: this.params.PAGE_NAV,
        };
    },

    created(props){


    },
    methods:{
      async showMore() {
        this.progress.show();
        await send(this.pagen.showMore, {method: "post"}, {}).then((response) => {
          this.pagen = response[this.params.responseKey].PAGE_NAV;
          this.itemsList = [...this.itemsList, ...response[this.params.responseKey].items];
          this.progress.hide();
        });
      }
    },
    computed: {
        windowMode(){

            if(window.innerWidth > 991) return 'xl';

            if(window.innerWidth <= 991 && window.innerWidth > 767) return 'md';

            return 'sm';

        },
        showAllButtonText() {
            if(this.windowMode === 'xl') return 'Смотреть весь рейтинг';

            if(this.windowMode === 'md') return 'Показать еще';

            return 'Войти';
        }
    }
}
</script>

<style lang="scss" scoped>
    .top-volunteers{
        background-color: var(--c-secondary-200);
        padding: 33px 0 108px 0;

        @media(max-width: 991px){
            padding-bottom: 106px;
        }

        @media(max-width: 767px){
            padding-bottom: 44px;
        }

        .show-all--button{
            margin-top: 38px;
            text-align: center;
            padding: 15.5px;
            color: white;
            border: 1px solid var(--c-secondary-300);
            border-radius: 6px;
            font-size: 14px;
            line-height: 19px;
            font-weight: 600;
            cursor: pointer;
            background-color: transparent;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0s;

            &:hover{
                background-color: var(--c-secondary-300);
            }

            @media(max-width: 991px){
                margin-top: 20px;
            }

            @media(max-width: 767px){
                margin-top: 21px;
                padding: 10.5px;
            }

        }
    }
</style>